import React from "react";

import { useGetCurrentAlerts } from "api/api-hooks/alerts-hooks";
import { Badge } from "primereact/badge";
import { Button } from "primereact/button";
import useAlertsStore from "store/alerts-store";
import AlertsPanel from "./AlertsPanel";

export default function AlertsBadge() {
  const { data: alerts } = useGetCurrentAlerts();
  const { togglePanel } = useAlertsStore();

  const unackedCritCount = alerts?.filter(a => !a.isAcknowledged && a.priority === "CRITICAL").length ?? 0;
  const unackedWarnCount = alerts?.filter(a => !a.isAcknowledged && a.priority === "WARNING").length ?? 0;
  const unackedNoticeCount = alerts?.filter(a => !a.isAcknowledged && a.priority === "NOTICE").length ?? 0;
  const hasCritical = alerts?.some(a => !a.isAcknowledged && a.priority === "CRITICAL");
  const warnSeverity = unackedWarnCount > 0 ? "warning" : undefined;

  const sortedAlerts = alerts
    ?.filter(a => !a.isAcknowledged)
    .sort((a, b) => {
      const priorityOrder = { CRITICAL: 0, WARNING: 1, NOTICE: 2 };
      const priorityDiff = priorityOrder[a.priority] - priorityOrder[b.priority];
      if (priorityDiff !== 0) return priorityDiff;
      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });

  const hasUnreadAlerts = !!sortedAlerts?.length;

  return (
    <>
      <Button
        onClick={togglePanel}
        className={`p-button-rounded  ${hasUnreadAlerts ? "pr-0 py-0" : ""}`}
        severity={hasCritical ? "danger" : warnSeverity}
        visible={!!alerts?.length}
      >
        <div className="flex flex-nowrap align-items-center">
          {hasUnreadAlerts && (
            <p className="m-0 truncate inline-block" style={{ maxWidth: "30vw" }}>
              {sortedAlerts[0].shortMessage || sortedAlerts[0].message}
            </p>
          )}
          <i className={`pi pi-bell ${hasUnreadAlerts ? "ml-2" : ""}`} />
          {hasUnreadAlerts && (
            <div
              className="bg-white-alpha-40 ml-1 flex flex-nowrap align-self-end p-2"
              style={{ borderRadius: "10rem" }}
            >
              {unackedCritCount > 0 && (
                <Badge
                  value={unackedCritCount > 99 ? "99+" : unackedCritCount}
                  severity="danger"
                  className="ml-0"
                />
              )}
              {unackedWarnCount > 0 && (
                <Badge
                  value={unackedWarnCount > 99 ? "99+" : unackedWarnCount}
                  severity="warning"
                  className="ml-0"
                />
              )}
              {unackedNoticeCount > 0 && (
                <Badge
                  value={unackedNoticeCount > 99 ? "99+" : unackedNoticeCount}
                  severity="info"
                  className="ml-0"
                />
              )}
            </div>
          )}
        </div>
      </Button>
      <AlertsPanel />
    </>
  );
}
